import { Amount, isAmount } from '@/types/amount';

type TypeGuardFn<T> = (value: unknown) => value is T;

export const isArray = <T>(value: unknown): value is ReadonlyArray<T> => {
  // FIXME: need to also check that elements are the same
  return Array.isArray(value);
};

export const isReadonlyArray = <T>(value: unknown): value is ReadonlyArray<T> => {
  // FIXME: need to also check that elements are the same
  return Array.isArray(value);
};

export const isReadonlyArrayOrNull = <T>(value: unknown): value is ReadonlyArray<T> | null => {
  return value === null || isReadonlyArray(value);
};

export const isString = (value: unknown): value is string => {
  return typeof value === 'string';
};

export const isStringOrNull = (value: unknown): value is string | null => {
  return value === null || isString(value);
};

export const isNumber = (value: unknown): value is number => {
  return typeof value === 'number';
};

export const isNumberOrNull = (value: unknown): value is number | null => {
  return value === null || isNumber(value);
};

export const isBoolean = (value: unknown): value is boolean => {
  return typeof value === 'boolean';
};

export const isBooleanOrNull = (value: unknown): value is boolean | null => {
  return value === null || isBoolean(value);
};

export const isObject = (value: unknown): value is Record<string, unknown> => {
  return value !== null && typeof value === 'object' && !Array.isArray(value);
};

export const isArrayOfString = (value: unknown): value is ReadonlyArray<string> | null => {
  return isArrayOf(value, isString);
};

export const isNull = (value: unknown): value is null => {
  return value === null;
};

export const isArrayOfStringOrNull = (value: unknown): value is ReadonlyArray<string> | null => {
  return isArrayOfOrNull(value, isString);
};

export const isArrayOf = <T>(value: unknown, isOfT: TypeGuardFn<T>): value is ReadonlyArray<T> => {
  return Array.isArray(value) && value.every(isOfT);
};

export const isFalse = (value: unknown): value is false => value === false;

// NOTE: WTF???
export const isNever = (value: null | never | unknown): value is never => value === null;

export const isArrayOfOrNull = <T>(
  value: unknown,
  isOfT: TypeGuardFn<T>,
): value is ReadonlyArray<T> | null => {
  return value === null || isArrayOf(value, isOfT);
};

export const isTrue = (value: unknown): value is true => {
  return value === true;
};

export const isFile = (value: unknown): value is File => {
  return value instanceof File;
};

export const isArrayOfFile = (value: unknown): value is ReadonlyArray<File> => {
  return isArrayOf(value, isFile);
};

export const isAmountOrNull = (value: unknown): value is Amount | null => {
  return value === null || isAmount(value);
};
